// Build the next demonstration while the visitor is still reading above it.
// Playback has a separate observer with no margin.
export function demoPreloadMargin(viewportHeight = window.innerHeight) {
  return `${Math.round(Math.max(1000, Math.min(2000, viewportHeight * 1.5)))}px 0px`;
}

export const DEMO_RETAIN_MS = 30000;
